import { ButtonBase, Checkbox, CheckboxProps, CircularProgress, FormControlLabel } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    spinner: {
        margin: "12px"  // must match checkbox
    }
}))

type LoadingCheckboxProps = CheckboxProps & Readonly<{
    loading: boolean
    label: string
}>

export function LoadingCheckbox({ loading, label, disabled, ...rest }: LoadingCheckboxProps) {
    const { classes } = useStyles()

    return (
        <FormControlLabel
            disabled={loading || disabled}
            control={
                loading ? (
                    <CircularProgress size={18} className={classes.spinner} />
                ) : (
                    <Checkbox
                        {...rest}
                    />
                )
            }
            label={label}
        />
    )
}
